<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="1"
      loader="bars"
    ></loading>
    <div class="container-scroller" style="background: #f9fafb">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div
          class="vh-100 content-wrapper auth-wrapper d-flex no-block d-flex justify-content-center align-items-center auth auth-img-bg"
        >
          <div class="row-login flex-grow">
            <div class="col-12">
              <div class="brand-logo" align="center">
                <img
                  src="../../assets/images/logo.png"
                  alt="logo"
                  height="45"
                />
              </div>
              <div class="auth-form-transparent">
                <div align="center">
                  <h5 class="pt-3">Create Password</h5>
                </div>
                <div
                  v-if="mssg"
                  align="center"
                  class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
                >
                  <p class="alert-close mb-0">
                    {{ mssg }}
                  </p>
                </div>
                <div
                  v-else-if="Errormssg"
                  align="center"
                  class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
                >
                  <p class="alert-close mb-0">
                    {{ Errormssg }}
                  </p>
                </div>
                <form v-if="validToken" @submit.prevent="onSubmit" class="pt-3">
                  <div class="form-group">
                    <label for="InputPassword">New Password</label>
                    <div class="form-group">
                      <input
                        type="password"
                        class="form-control"
                        id="InputPassword"
                        required="required"
                        v-model="password"
                        name="password"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="Confirm_InputPassword">Confirm Password</label>
                    <div class="form-group mb-2">
                      <input
                        type="password"
                        class="form-control"
                        id="Confirm_InputPassword"
                        required="required"
                        v-model="confirm_password"
                        name="password"
                      />
                      <p class="small gray4">
                        Strong passwords should be 8 characters long with a mix
                        of upper case, lower case, and special characters
                      </p>
                    </div>
                    <p v-if="Errorpass" class="small text-error p-1 mb-0">
                      {{ Errorpass }}
                    </p>
                    <div
                      style="height: 0.25rem; border-radius: 5px"
                      :class="getClass()"
                    ></div>
                  </div>

                  <div class="my-3" align="center">
                    <button type="submit" class="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- content-wrapper ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Login",
  data() {
    return {
      password: "",
      confirm_password: "",
      validToken: false,
      Errorpass: "",
      mssg: "",
      Errormssg: "",
      isLoading: true,
      fullPage: true,
    };
  },
  mounted() {
    this.verifyUser({ token: this.$route.params.token })
      .then(() => {
        this.validToken = true;
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        this.Errormssg = error.response.data.message;
        // error.response can be null
        if (error.response) {
          console.error(error.response.data.message);
        }
      });
  },
  components: {
    Loading,
  },
  computed: {
    scorePassword() {
      let score = 1;
      let password = "";
      for (let i = 0; i < this.password.length; i++) {
        if (this.password[i] === this.confirm_password[i]) {
          password += this.password[i];
        } else {
          break;
        }
      }
      // //console.log(password, "password")
      // //console.log(password.length)
      if (password === "") return score;
      if (password.length >= 8) {
        score++;
      }
      let variations = [
        /\d/.test(password),
        /[a-z]/.test(password),
        /[A-Z]/.test(password),
        /\W/.test(password),
      ];
      for (let i = 0; i < variations.length; i++) {
        if (variations[i] === true) {
          score++;
        }
      }
      // //console.log(score, "score");
      return parseInt(score);
    },
  },
  methods: {
    ...mapActions(["createPassword", "verifyUser"]),
    getClass() {
      if (this.scorePassword < 2) return "bg-gray2 w-100";
      if (this.scorePassword == 2) return "bg-danger w-25";
      else if (this.scorePassword == 3 || this.scorePassword == 4)
        return "bg-orange w-50";
      else if (this.scorePassword == 5) return "bg-warning w-75";
      else if (this.scorePassword == 6) return "bg-success w-100";
    },
    onSubmit() {
      this.Errorpass = "";
      //console.log(this.scorePassword, "score")
      if (this.password !== this.confirm_password) {
        this.Errorpass = "Passwords don't match";
      } else {
        if (this.password.length < 8) {
          this.Errorpass = "Password must be at least 8 Characters";
        } else if (this.scorePassword < 5) {
          this.Errorpass =
            "Password must contain at least one uppercase, one lowercase, and one special character";
        } else {
          this.isLoading = true;
          const password = {
            password: this.password,
          };
          this.createPassword({ token: this.$route.params.token, password })
            .then((res) => {
              this.isLoading = false;
              if (res.data.success) {
                this.mssg = res.data.message;
                setTimeout(() => {
                  this.isLoading = true;
                }, 1000);
                setTimeout(() => {
                  this.$router.push("/login");
                }, 4000);
              }
            })
            .catch((error) => {
              this.isLoading = false;
              this.Errormssg = error.response.data.message;
              // error.response can be null
              if (error.response) {
                console.error(error.response.data.message);
              }
            });
        }
      }
    },
  },
};
</script>

